<template>
  <div class="m-tinymce-primary">
    <AtomLoadingSecondary v-show="showLoadingState"/>
    <form
      v-show="!showLoadingState"
      autocomplete="off"
      @submit.prevent="updateAcademiaLegales"
    >
      <AtomTinymcePrimary
        v-model="legal.texto"
        name="mensaje"
      />
      <AtomButtonPrimary :button-primary="buttonPrimary"/>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyLegalsEmailClause',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionAcademyLegalsEmailClause.buttonPrimary'),
        class: 'a-button-academy-primary',
        sending: false,
        type: 'submit'
      },

      legal: {
        texto: '',
        tipo: 'email'
      },

      showLoadingState: true,
      storedAcademyLegals: {}
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.storedAcademyLegals = this.$store.getters.getAcademyLegals
    if (Object.keys(this.storedAcademyLegals).length === 0) {
      this.readAcademiaLegales()
    } else {
      this.legal.texto = this.storedAcademyLegals.email
      this.showLoadingState = false
    }
  },

  methods: {
    readAcademiaLegales () {
      this.$services.read('academia', 'readAcademiaLegales', {}, [this.academiaId])
        .then(response => {
          this.legal.texto = response.data.email
          this.$store.commit('setAcademyLegals', response.data)
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    updateAcademiaLegales () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.create('academia', 'updateAcademiaLegales', this.legal, [this.academiaId])
          .then(response => {
            this.$alerts.pushAlert('mEditionAcademyLegalsEmailClause', 'updateAcademiaLegales', 'success')
            this.readAcademiaLegales()
            this.$license.readAcademiaConfiguracionGlobal()
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAcademyLegalsEmailClause', 'updateAcademiaLegales', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
